import './global.scss' // app & third-party component styles

import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, HashRouter, useNavigate, useLocation } from 'react-router'
import { Provider } from 'react-redux'
import { ApolloProvider } from '@apollo/client'
import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { Store } from 'redux'

import { getRouterType } from 'env'
import globalHistory from './history'

import Localization from './localization'
import Router from './router'
import MaintenanceGuard from './maintenance'

export default function rootRender(
  appolloClient: ApolloClient<NormalizedCacheObject>,
  store: Store<any, any>,
  history: typeof globalHistory,
): void {
  const NavigateSetter = () => {
    const navigate = useNavigate()
    const location = useLocation()

    history.navigate = navigate as any
    history.location = location as any

    const { notifyLocationChange } = history

    useEffect(() => {
      notifyLocationChange(location as any)
    }, [location, notifyLocationChange])

    return null
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

  const routerType = getRouterType()

  const CurrentRouter = routerType === 'hash' ? HashRouter : BrowserRouter

  root.render(
    <ApolloProvider client={appolloClient}>
      <CurrentRouter>
        <NavigateSetter />
        <Provider store={store}>
          <MaintenanceGuard>
            <Localization>
              <Router />
            </Localization>
          </MaintenanceGuard>
        </Provider>
      </CurrentRouter>
    </ApolloProvider>,
  )
}
